import { Box, Typography } from '@mui/material';

import { FHConfirmDialog } from '../../../../components/base';
import {
  EVENT_WARNING_CONTENT_SX,
  EVENT_WARNING_DETAIL_TEXT_SX,
  EVENT_WARNING_DIALOG_SX,
  EVENT_WARNING_DIALOG_TITLE_SX,
  EVENT_WARNING_TEXT_SX,
} from '../styles';

import type { ISessionInfoDialogsProps } from '../types';

export default function SessionInfoDialogs({
  handleClientChange,
  handleDeleteSession,
  handleSubmit,
  openClientConfirm,
  openConfirm,
  setOpenClientConfirm,
  setOpenConfirm,
  setShowConfirmDeleteDialog,
  setShowDurationEventWarning,
  setShowRateEventWarning,
  showConfirmDeleteDialog,
  showDurationEventWarning,
  showRateEventWarning,
}: ISessionInfoDialogsProps) {
  return (
    <>
      <FHConfirmDialog
        open={showConfirmDeleteDialog}
        title="Delete session"
        content="Are you sure you want to delete this session? This action cannot be undone."
        submittext="Yes, delete"
        canceltext="Cancel"
        submitBtnTestId="deleteBtn"
        cancelBtnTestId="cancelBtn"
        onClose={() => setShowConfirmDeleteDialog(false)}
        onSubmit={handleDeleteSession}
      />
      <FHConfirmDialog
        open={openConfirm}
        content="Session time has not been changed from the default time. Are you sure you want to continue?"
        submittext="Continue"
        canceltext="Edit Time"
        onClose={(event, reason) => {
          if (reason && reason === 'backdropClick') return;
          setOpenConfirm(false);
        }}
        onSubmit={handleSubmit}
      />
      <FHConfirmDialog
        open={openClientConfirm}
        content="Are you sure you want to change to a different client?"
        submittext="Continue"
        canceltext="Back to session note"
        onClose={() => setOpenClientConfirm(false)}
        onSubmit={() => {
          handleClientChange();
          setOpenClientConfirm(false);
        }}
      />
      <FHConfirmDialog
        open={showRateEventWarning}
        title="Events outside the session time"
        titleStyles={EVENT_WARNING_DIALOG_TITLE_SX}
        dialogStyles={EVENT_WARNING_DIALOG_SX}
        contentRenderer={() => (
          <Box sx={EVENT_WARNING_CONTENT_SX}>
            <Typography sx={EVENT_WARNING_TEXT_SX}>
              There are existing events that fall outside the updated <br /> start date and
              duration.
            </Typography>
            <Typography sx={EVENT_WARNING_DETAIL_TEXT_SX}>
              Please delete or adjust these events before <br /> proceeding with the update.
            </Typography>
          </Box>
        )}
        submittext="Okay"
        hideCancelButton
        onClose={() => setShowRateEventWarning(false)}
        onSubmit={() => {
          setShowRateEventWarning(false);
        }}
      />
      <FHConfirmDialog
        open={showDurationEventWarning}
        title="Duration events outside the session time"
        titleStyles={EVENT_WARNING_DIALOG_TITLE_SX}
        dialogStyles={EVENT_WARNING_DIALOG_SX}
        contentRenderer={() => (
          <Box sx={EVENT_WARNING_CONTENT_SX}>
            <Typography sx={EVENT_WARNING_TEXT_SX}>
              There are existing duration events that fall outside the updated session duration.
            </Typography>
            <Typography sx={EVENT_WARNING_DETAIL_TEXT_SX}>
              Please delete or adjust these events before <br /> proceeding with the update.
            </Typography>
          </Box>
        )}
        submittext="Okay"
        hideCancelButton
        onClose={() => setShowDurationEventWarning(false)}
        onSubmit={() => {
          setShowDurationEventWarning(false);
        }}
      />
    </>
  );
}
